const Logo = () => {
  return <h1 className='text-3xl font-bold text-green-600 '>Estudy</h1>
}

export default Logo;